<template lang="html">
  <div id="mainpage">
    <app-header></app-header>
    <div id="headerBlank"></div>
    <router-view></router-view>
  </div>

</template>

<script>
import AppHeader from '@/components/header/AppHeader'
export default {
  components: {
    'app-header': AppHeader
  }
}
</script>

<style lang="css" scoped>
#headerBlank {
  height: 50px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// MainPage.vue?2a4c60ce